export const IntegrationsPanel = {
  flow: 'y',
  fontSize: 'Z2',
  padding: 'A+Z Z2',
  gap: 'C',
  overflow: 'hidden auto',
  ImportInInsert: {},
  Line_3: {
    margin: '- -A',
  },
  DataSourcesInInsert: {},
  Line_4: {
    margin: '- -A',
  },
  IntegrationsInInsert: {},
};